module.exports = __webpack_public_path__ + "img/tr_p_candidates_faq.65540a19.jpg";